/**
 * Tira a `description` dos itens do pedido antes do POST /restaurant/{id}/order (e /order/table).
 *
 * Por que existe: a descrição do produto é o HTML do editor de cardápio (`<p><span style="color:…">`),
 * e a regra CrossSiteScripting_BODY do WAF da API marca esse corpo como XSS (visto em 25–26/10/2026,
 * hoje em Count). O server não lê nem grava descrição de item no pedido: `order_items` não tem a
 * coluna e a resposta vem do banco. Então ela sai do corpo, em qualquer nível dos itens (sabores,
 * adicionais, itens de combo).
 *
 * Devolve uma cópia: o carrinho (`this.order`) continua com a descrição para a tela.
 */
const semDescricao = (valor: unknown): unknown => {
    if (Array.isArray(valor)) return valor.map(semDescricao);
    if (!valor || typeof valor !== 'object') return valor;
    const copia: Record<string, unknown> = {};
    Object.keys(valor).forEach((chave) => {
        if (chave !== 'description') copia[chave] = semDescricao((valor as Record<string, unknown>)[chave]);
    });
    return copia;
};

export function semDescricaoDosItens<T extends { orders?: unknown }>(pedido: T): T {
    if (!pedido || !Array.isArray(pedido.orders)) return pedido;
    return { ...pedido, orders: semDescricao(pedido.orders) } as T;
}
